import React from 'react';
import { Box } from '@material-ui/core';

import TopBar from './components/Topbar';
import PaymentForm from './components/PaymentForm';
import CheckoutFramesLoader from './components/CheckoutFramesLoader/CheckoutFramesLoader';
import PaymentSettingsProvider from 'components/context/PaymentSettings/PaymentSettingsProvider';
import { useIsDesktop } from 'components/utilities';

const Payment = () => {
	const isDesktop = useIsDesktop();

	return (
		<PaymentSettingsProvider>
			<Box>
				<TopBar />
				<Box p={isDesktop ? 2 : 0} display="flex" justifyContent="center">
					<CheckoutFramesLoader>
						<PaymentForm />
					</CheckoutFramesLoader>
				</Box>
			</Box>
		</PaymentSettingsProvider>
	);
};

export default Payment;
